import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  updateSearch,
  updateSearchResults,
  updateSearchType,
  updateSearchTerm,
  updateSearchIsOpen,
} from '../../actions/search.jsx';
import './AppSearch.scss';
import GeckoLocation from 'services/gecko-location';
import GeckoRequest from 'services/gecko-request';
import GeckoFeatures from 'services/gecko-features';
import { GeckoIcon, GeckoToastService } from 'ui';
import { CONSTS } from 'constants/index.js';

class AppSearch extends Component {
  state = {
    isOpen: false,
    term: this.props.term,
    suggestions: [],
    fetching: false,
  };

  static contextTypes = {
    history: PropTypes.object,
  };

  componentDidMount() {
    this.updateSearch(this.props.term);
  }

  updateSearch(term) {
    GeckoRequest.post('/search', { term })
      .then((tags) => this.setState({ suggestions: tags }))
      .catch(console.error);
  }

  handleChange(event) {
    this.setState({ term: event.target.value, isOpen: true });
    this.props.updateTerm(event.target.value || '');
    this.updateSearch(event.target.value);
  }

  handleFocus() {
    this.setState({ isOpen: true });
  }

  handleBlur(event) {
    setTimeout(() => {
      this.setState({ isOpen: false });
    }, 300);
  }

  handleEnterPress(e) {
    if (e.key === 'Enter') {
      this.setState({ isOpen: false });
      this.props.onSearch();

      if (this.state.term.trim().length < 3) {
        return new GeckoToastService().warning(
          'Search term must be at least 3 characters'
        );
      }

      return GeckoLocation.goTo('/results/conversations', {
        search: this.state.term,
      });
    }
  }

  renderSuggestions() {
    if (this.state.term && this.state.isOpen) {
      return (
        <ul>
          {this.state.suggestions.map((tag) =>
            this.renderSuggestion('tag', tag.name, tag.id)
          )}

          {GeckoFeatures.can('recent-conversations') &&
            this.renderSuggestion(
              'recent_conversation',
              `'${this.state.term}'`
            )}
          {this.renderSuggestion('conversation', `'${this.state.term}'`)}
          {this.renderSuggestion('contact', `'${this.state.term}'`)}
          {this.renderSuggestion('agent', `'${this.state.term}'`)}
        </ul>
      );
    }
    return null;
  }

  renderSuggestion(type, content, id) {
    const affix = {
      tag: (
        <span>
          <i className="far fa-tag"></i>Tag:{' '}
        </span>
      ),
      conversation: (
        <span>
          <i className="far fa-message-lines"></i>Conversation contains:{' '}
        </span>
      ),
      contact: (
        <span>
          <i className="far fa-address-book"></i>Contact contains:{' '}
        </span>
      ),
      agent: (
        <span>
          <i className="far fa-user"></i>Agent contains:{' '}
        </span>
      ),
    };
    const search = () => {
      this.props.onSearch();
      if (type === 'contact') {
        return GeckoLocation.goTo('/contacts', { search: this.state.term });
      } else if (type === 'agent') {
        return GeckoLocation.goTo('/agents', { search: this.state.term });
      } else if (type === 'tag') {
        this.setState({ term: content, isOpen: true });
        this.props.updateTerm(content || '');
        if (GeckoLocation.location.pathname.indexOf('/conversations') !== -1) {
          // If we are already on the Conversations page go to the same path but just change the filter
          return GeckoLocation.goTo(GeckoLocation.location.pathname, {
            filter: CONSTS.FILTER_TAG,
            tag: id,
          });
        } else {
          return GeckoLocation.goTo('/conversations', {
            filter: CONSTS.FILTER_TAG,
            tag: id,
          });
        }
      } else {
        if (this.state.term.trim().length < 3) {
          return new GeckoToastService().warning(
            'Search term must be at least 3 characters'
          );
        }
        return GeckoLocation.goTo('/results/conversations', {
          search: this.state.term,
        });
      }
    };
    return (
      <li key={type + content} onClick={search.bind(this)}>
        {affix[type]}
        {content}
      </li>
    );
  }

  render() {
    return (
      <div>
        <div className="AppSearch">
          {this.state.fetching ? (
            <GeckoIcon icon="far fa-spinner spin" />
          ) : (
            <GeckoIcon icon="far fa-search" />
          )}
          <input
            id="AppSearch"
            type="text"
            placeholder="Search"
            value={this.props.term}
            onChange={this.handleChange.bind(this)}
            onBlur={this.handleBlur.bind(this)}
            onFocus={this.handleFocus.bind(this)}
            onKeyDown={(e) => this.handleEnterPress(e)}
            disabled={this.state.fetching}
          />
          {this.renderSuggestions()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    defaultHeaders: store.appState.defaultHeaders,
    results: store.searchResults.results,
    type: store.searchResults.type,
    term: store.searchResults.term,
    isOpen: store.searchResults.isOpen,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateSearch: (obj) => {
      dispatch(updateSearch(obj));
    },
    updateResults: (results) => {
      dispatch(updateSearchResults(results));
    },
    updateType: (type) => {
      dispatch(updateSearchType(type));
    },
    updateTerm: (term) => {
      dispatch(updateSearchTerm(term));
    },
    updateIsOpen: (isOpen) => {
      dispatch(updateSearchIsOpen(isOpen));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AppSearch);
